module.exports = __webpack_public_path__ + "static/media/bg-1.0c049c7c.jpg";